import { DashboardPage } from '@/components/pages/account/DashboardPage'
import { withAuthentication } from '@/elements/global/AuthenticatedPage'

export default withAuthentication(DashboardPage, true)
